import styled from 'styled-components';

export const AboutusContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 1em 2em;
  margin: 1em 0;

  & .section {
    @media (max-width: 720px) {
      margin-bottom: 1.3em;
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 1em;
  }
`;
export const Title = styled.h3`
  font-size: 18px;
  color: rgb(0 0 0 / 87%);
  padding-bottom: 10px;
  font-weight: 700;
  height: ${(props) => (props.aboutMylo ? '32.4px' : 'auto')};
`;

export const Superpowercontent = styled.p`
  color: #000000ad;
  width: 85%;
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 500;
  height: ${(props) => (props.aboutMylo ? '170px' : 'auto')};

  @media (max-width: 720px) {
    width: 100%;
  }
`;

export const Superpowersection = styled.div`
  padding: 1em 2em 1em;
  @media (max-width: 720px) {
    padding: 0 1em;
  }
  p {
    color: #000000ad;
    padding: 10px 0;
  }
`;

export const Superpowerimg = styled.img`
  width: 230px;
  height: auto;
  padding-bottom: 16px;
`;

export const Playstorebtn = styled.div`
  margin: 20px 0;
`;
